import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "list-summary-option" }
const _hoisted_2 = { class: "no-mb" }
const _hoisted_3 = { style: {"font-size":"12px","font-weight":"400"} }


import { WarningTwoTone } from '@ant-design/icons-vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ListSummaryOption',
  props: {
    option: null,
    lastItem: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { option: { externalRef:string, name:string|null, price:string|null, qty:number, excluded_from_warranty:boolean, vat_rate:number }, lastItem:boolean };



return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_divider = _resolveComponent("a-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_row, {
      gutter: [16,16],
      class: "no-mb"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 3 }, {
          default: _withCtx(() => [
            _createElementVNode("h4", null, _toDisplayString(props.option.qty) + "x", 1)
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 21 }, {
          default: _withCtx(() => [
            _createElementVNode("h4", null, [
              _createTextVNode(_toDisplayString(props.option.externalRef) + " - " + _toDisplayString(props.option.name) + " ", 1),
              (props.option.excluded_from_warranty)
                ? (_openBlock(), _createBlock(_unref(WarningTwoTone), {
                    key: 0,
                    "two-tone-color": "#f38929",
                    style: {"margin-left":"4px"}
                  }))
                : _createCommentVNode("", true)
            ]),
            _renderSlot(_ctx.$slots, "subtitle"),
            _createElementVNode("p", _hoisted_2, [
              _createTextVNode("€" + _toDisplayString(props.option.price.toLocaleString('nl-NL')) + " ", 1),
              _createElementVNode("span", _hoisted_3, "incl. " + _toDisplayString(props.option.vat_rate) + "% BTW", 1)
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }),
    (!props.lastItem)
      ? (_openBlock(), _createBlock(_component_a_divider, {
          key: 0,
          style: { margin: '12px 0' }
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})